<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    var currentIcon = "/logoicon.ico"; //可通过后端动态获取名称
    var link = document.querySelector('link[rel*="icon"]');
     link.href = currentIcon;
     console.log("link============>",link)
     console.log("enter replace")
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue